
import { toast } from "react-toastify"
import { fetchConToken } from "../helpers/fetch"

export const Settings = {

    getInfoProp: async (id) => {
        try {

            const resp = await fetchConToken(`ajustes/info-propietaria`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null
            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    update: async (data) => {
        try {

            const resp = await fetchConToken(`ajustes/info-propietaria/update/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    updateInfoPpto: async (data) => {
        try {

            const resp = await fetchConToken(`ajustes/generales/ppto/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    updateInfoGasto: async (data) => {
        try {

            const resp = await fetchConToken(`ajustes/generales/gastos/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    saveNewUser: async (data) => {
        try {

            const resp = await fetchConToken(`usuarios`, data, "POST")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getUsers: async (data) => {
        try {

            const resp = await fetchConToken(`usuarios/all/users`)
            const body = await resp.json()
            console.log('--users list--', body.data)

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    updateEstadoUser: async (data) => {
        try {

            const resp = await fetchConToken(`usuarios/update/estado/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    updateEstado: async (data) => {
        try {

            const resp = await fetchConToken(`rules/update/status/${data.id}`, data, "PUT")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getPerfiles: async () => {
        try {

            const resp = await fetchConToken(`ajustes/perfiles`)
            const body = await resp.json()

            if (body.ok) {
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    saveNewRuleProfit: async (data) => {
        try {

            const resp = await fetchConToken(`rules`, data, "POST")
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data

            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log(error)
            toast.error(error)
        }
    },

    getAllRules: async (data) => {
        try {

            const resp = await fetchConToken(`rules`)
            const body = await resp.json()

            if (body.ok) {
                console.log('--rules--', body.data)
                return body.data || null

            } else {
                toast.error('Lo sentimos, ocurrió un error')
                return null
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    },

    deleteRule: async (id) => {
        try {

            const resp = await fetchConToken(`rules/${id}`, {}, 'DELETE')
            const body = await resp.json()

            if (body.ok) {
                toast.success(body.msg)
                return body.data
            } else {
                toast.error(body.msg)
                return 0
            }

        } catch (error) {
            console.log('---error--', error)
            toast.error(error)
        }
    }

}